export default "__VITE_ASSET__BCFjC1b2__"